import apiClient from "./apiClient"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const patientConditionIssuesSummary = {
	type: ApiTag.PatientCondition,
	id: "issues/summary"
}

const patientConditionIssuesEndpoints = (build: McoEndpointBuilder) => ({
	patientConditionIssuesGetFilters: build.query({
		queryFn: (_: void) => apiClient.patient.condition.issues.getFilters(),
		providesTags: [ApiTag.Tenant]
	}),
	patientConditionIssuesGetSummary: build.query({
		queryFn: apiClient.patient.condition.issues.getAllSummary,
		providesTags: [ApiTag.Tenant, patientConditionIssuesSummary]
	}),
	patientConditionIssuesGet: build.query({
		queryFn: apiClient.patient.condition.issues.get,
		providesTags: (_, __, patientConditionId) => [
			ApiTag.Tenant,
			{
				type: ApiTag.PatientCondition,
				id: `issues/${patientConditionId}`
			}
		]
	}),
	patientConditionIssuesMarkAsOk: build.mutation({
		queryFn: apiClient.patient.condition.issues.markAsOk,
		invalidatesTags: (_, __, patientConditionId) => [
			ApiTag.Tenant,
			{
				type: ApiTag.PatientCondition,
				id: `issues/${patientConditionId}`
			}
		]
	}),
	patientConditionIssuesFix: build.mutation({
		queryFn: apiClient.patient.condition.issues.fixAssessmentIssue,
		invalidatesTags: (_, __, request) => [
			ApiTag.Tenant,
			{
				type: ApiTag.PatientCondition,
				id: `issues/${request.patientConditionId}`
			}
		]
	})
})

export default patientConditionIssuesEndpoints
